import { render, staticRenderFns } from "./ClaimSubCategory.vue?vue&type=template&id=9d0120f2"
import script from "./ClaimSubCategory.vue?vue&type=script&lang=js"
export * from "./ClaimSubCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports